module.exports = __webpack_public_path__ + "static/logo-7b4cd7e09efa77c57aced282c0bfbdcf.jpg";